import React from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { Footer7 } from "./footer-7";
import { contactInfo } from "../data/mockData";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background text-foreground">
      <Footer7
        logo={{
          url: "/",
          src: "https://i.imgur.com/upzKk4Y.png",
          alt: "RG Servicio Técnico",
          title: "RG Servicio Técnico"
        }}
        description="Brindamos servicios técnicos profesionales para PC, notebooks, consolas y celulares. Más de 300 equipos reparados y 98% de satisfacción."
        sections={[
          {
            title: "Servicios",
            links: [
              { name: "Diagnóstico", href: "/#diagnostico" },
              { name: "Servicios", href: "/servicios#servicios" },
              { name: "Packs", href: "/servicios#packs" },
              { name: "Planes", href: "/servicios#planes" }
            ]
          },
          {
            title: "Navegación",
            links: [
              { name: "Trabajos", href: "/nosotros#trabajos" },
              { name: "Tienda", href: "/tienda" },
              { name: "Diagnóstico", href: "/#diagnostico" },
              { name: "Asistente", href: "/ayuda" },
              { name: "Velocidad", href: "/velocidad" },
              { name: "Contacto", href: "/#contacto" }
            ]
          },
          {
            title: "Contacto",
            links: [
              { name: "WhatsApp", href: `https://wa.me/${contactInfo.whatsapp}` },
              { name: "contacto@rgserviciotecnico.com", href: "mailto:contacto@rgserviciotecnico.com" },
              {
                name: "Lincoln, Buenos Aires",
                href: "https://www.google.com/maps/place/RG+Servicio+T%C3%A9cnico/@-34.8538401,-61.5381745,17z/data=!3m1!4b1!4m6!3m5!1s0x95c743345c1680f7:0x1a9da2c60de1e6fc!8m2!3d-34.8538401!4d-61.5355996!16s%2Fg%2F11xvf4pgzx?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D"
              },
              { name: "Solo con cita previa. Contáctanos para coordinar.", href: null }
            ]
          }
        ]}
        socialLinks={[
          { icon: <FaInstagram className="size-5" />, href: "https://www.instagram.com/rgserviciotec", label: "Instagram" },
          { icon: <FaFacebook className="size-5" />, href: "https://www.facebook.com/profile.php?id=61566948740791", label: "Facebook" },
          { icon: <FaTiktok className="size-5" />, href: "https://www.tiktok.com/foryou", label: "TikTok" }
        ]}
        copyright={`© ${currentYear} RG Servicio Técnico. Todos los derechos reservados.`}
        legalLinks={[]}
      />
    </footer>
  );
};

export default Footer;
